<template>
  <div class="switch-element">
    <div v-if="label" class="label tooltip">
      {{ this.label }}
      <span v-if="tooltip" class="tooltiptext">
        {{ this.tooltip }}
      </span>
    </div>
    <label class="switch"  ref="refSwitch">
      <input type="checkbox" :value="rendeValue"/>
      <span @click="click($event)" class="slider round"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: "m-switch",
  props: {
    label: {
      default: ""
    },
    value: {
      default: false
    },
    tooltip: {
      default: ""
    },
    switchChange: {}
  },
  data() {
    return {
      rendeValue: null,
    }
  },
  watch: {
    value() {
      this.rendeValue = this.value
    }
  },
  mounted() {
    this.rendeValue = this.value
    if (this.value) {
      this.$refs.refSwitch.click();
    }
  },
  methods: {
    click($event) {
      this.$emit("input", !this.value);
      this.$emit("change", $event);
      if (typeof this.switchChange == "function") this.switchChange($event);
    }
  }
};
</script>

<style lang="scss" scoped>
.switch-element {
  display: flex;
}

.label {
  margin-right: 5px;
}
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bg);
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: var(--primary);
}

input:focus + .slider {
  box-shadow: 0 0 1px var(--primary);
}

input:checked + .slider:before {
  -webkit-transform: translateX(20px);
  -ms-transform: translateX(20px);
  transform: translateX(20px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
